import React, { useEffect, useState } from "react";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { Form, Row, Col, Dropdown } from "react-bootstrap";
import noimage from "../../assets/img/noimage.png";
import { useLocation, useNavigate } from "react-router-dom";
import config from "../../config/config";
import { toast } from "react-toastify";
import {
  categoryGet,
  categroyEdit,
  categroyEditaxios,
  editSubCategory,
  netWorkEdit,
} from "../../Actions/axios";
import { isEmpty } from "../../Actions/common";

const SubCategoryEdit = () => {
  const location = useLocation();
  const [data, setData] = useState({});
  const [err, setErr] = useState({});
  const navigate = useNavigate();
  const [catlist, setCatList] = useState([]);
  const [selCat,setSelCat]=useState("")

  const getcategoryGet = async () => {
    let resp = await categoryGet({
      page: 0,
      limit: Number.MAX_SAFE_INTEGER,
    });
    console.log("🚀 ~ getcategoryGet ~ resp:", resp);
    if (resp?.status) {
      setCatList(resp?.data);
    }
  };
  const onChangeFunc = (e, i) => {
    var { name, value, files } = e.target;
    console.log("🚀 ~ onChangeFunc ~ e.target:", e.target);
    setData({ ...data, [name]: files ? files[0] : value });
    if(name == "catId"){
      setSelCat(e.target.data)
    }
  };

  const validataion = async () => {
    let err = {};
    await Promise.all(
      Object.keys(data)?.map((val) => {
        console.log(val, data[val], data[val]?.name, isEmpty(data[val]?.name));
        if (val == "file") {
          if (val == "file" && isEmpty(data[val]?.name)) {
            err[val] = `${val} is required`;
          }
        } else {
          if (isEmpty(data[val])) {
            err[val] = `${val} is required`;
          }
        }
      })
    );
    setErr(err);
    return err;
  };

  const EditCategoryData = async () => {
    let err = await validataion();
    console.log("🚀 ~ EditNetworkData ~ err:", err);
    if (!isEmpty(err)) {
      return toast.error("Field Required");
    }
    let resp = await editSubCategory(data);
    console.log("🚀 ~ EditNetworkData ~ resp:", resp);
    if (resp?.status) {
      toast.success(resp?.message);
      navigate("/subcategorylist");
    } else {
      toast.error(resp?.message);
    }
  };

  useEffect(() => {
    let incomData = location?.state;
    delete incomData.__v;
    setData({...incomData,['catId'] : incomData?.catId?._id});
    getcategoryGet();
    setSelCat(incomData?.catId?.name)
  }, [location]);

  return (
    <>
      <div className="cmsedit">
        <button className="btn sitebtn mb-4" onClick={() => navigate(-1)}>
          Back
        </button>
        <h1 className="pagehead">Category Edit</h1>
        <div className="cardbox">
          <Form>
            <Row>
              <Col xs={12} sm={12} md={6} lg={6} className="mb-4">
                <Form.Group>
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    onChange={onChangeFunc}
                    value={data?.name}
                  />
                  {err?.name && <p>{err?.name}</p>}
                </Form.Group>
              </Col>
              <Col xs={12} sm={12} md={6} lg={6} className="mb-4">
                <div className="mb-3">
                  <label>Category</label>
                  <Dropdown
                    className="reqdrop"
                    onSelect={(e) => {
                      console.log("e-->", e);
                      onChangeFunc({
                        target: {
                          name: "catId",
                          value: e.split(",")[0],
                          data: e.split(",")[1],
                        },
                      });
                    }}
                  >
                    <Dropdown.Toggle
                      className="w-100 text-start"
                      variant="success"
                      id="dropdown-basic"
                    >
                      {selCat == "" ? "Select Category" : selCat}
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="w-100">
                      {catlist?.map((val) => (
                        <Dropdown.Item eventKey={`${val?._id},${val.name}`}>
                          {val?.name}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                  {err?.category && <p>{err?.category}</p>}
                </div>
              </Col>
              <Col xs={12} sm={6} className="mb-4">
                <Form.Group>
                  <Form.Label>Image</Form.Label>
                  <div className="uploadimgbox">
                    <img
                      src={
                        data?.file
                          ? URL.createObjectURL(data?.file)
                          : `${config.Back_URL}subcategory/${data?.logo}`
                      }
                      alt="user"
                      className="img-fluid"
                    />
                    <Form.Control
                      type="file"
                      name="file"
                      onChange={onChangeFunc}
                    />
                  </div>
                </Form.Group>
              </Col>
            </Row>
          </Form>
          <button
            type="button"
            onClick={() => {
              EditCategoryData();
            }}
            className="btn sitebtn py-2 px-3 mt-4"
          >
            Edit
          </button>
        </div>
      </div>
    </>
  );
};

export default SubCategoryEdit;
